export enum PriceSimulationChoice {
    "", "Elektriciteit", "Gas"
}